"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadScLocal = exports.instantiateSC = void 0;
const msgPack = __importStar(require("@thepowereco/msgpack"));
const sc_interface_1 = require("./sc-interface/sc-interface");
const _1 = require(".");
const instantiateSC = async (address, chain = 8, isHTTPSNodesOnly = false) => {
    const loadedSC = {};
    const network = new _1.NetworkApi(chain);
    await network.bootstrap(isHTTPSNodesOnly);
    loadedSC[address] = loadedSC[address] || (await network.loadScCode(address));
    const state = await network.loadScState(address);
    return new sc_interface_1.SmartContractWrapper(loadedSC[address], state);
};
exports.instantiateSC = instantiateSC;
const loadScLocal = (code, state = {}, balance = {}) => (new sc_interface_1.SmartContractWrapper(code, msgPack.encode(state), balance));
exports.loadScLocal = loadScLocal;
